import { render, staticRenderFns } from "./SampleLayout.vue?vue&type=template&id=6358ece0"
import script from "./SampleLayout.vue?vue&type=script&lang=js"
export * from "./SampleLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6358ece0')) {
      api.createRecord('6358ece0', component.options)
    } else {
      api.reload('6358ece0', component.options)
    }
    module.hot.accept("./SampleLayout.vue?vue&type=template&id=6358ece0", function () {
      api.rerender('6358ece0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/SampleLayout.vue"
export default component.exports